import { HubConnectionBuilder } from '@microsoft/signalr';
import vars from '@/config/vars';

let connection;

export default {
    CreateConnection() {
        connection = new HubConnectionBuilder()
            .withUrl(vars.PAYMENT_NOTIFICATION_HUB_URL)
            .build();
    },

    async StartConnection(orderId) {
        await connection.start({ withCredentials: false });
        await this.RegisterForNotification(orderId);
    },

    async RegisterForNotification(orderId) {
        await connection.invoke('RegisterOrder', orderId);
    },

    OnStatusChange(callback) {
        connection.on('StatusUpdated', callback);
    },

    CloseConnection() {
        connection.stop();
    }
};
